import React from "react";
import "./Hero.css";
import { useTranslation } from "react-i18next";

const Hero: React.FC = () => {
  const { t } = useTranslation() as { t: (key: string) => string };

  return (
    <div className="hero">
      <div className="hero_overlay">
        <h2 className="hero_title">{t("heroTitle")}</h2>
        <p className="hero_subtitle">{t("heroSubtitle")}</p>
      </div>
    </div>
  );
};

export default Hero;
